import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 27.333C9.74 27.333 4.667 22.26 4.667 16S9.74 4.667 16 4.667 27.333 9.74 27.333 16 22.26 27.333 16 27.333m0-2.666a8.667 8.667 0 1 0 0-17.334 8.667 8.667 0 0 0 0 17.334",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16 26.333c-5.707 0-10.333-4.626-10.333-10.333S10.293 5.667 16 5.667 26.333 10.293 26.333 16 21.707 26.333 16 26.333m0-.666A9.667 9.667 0 0 0 25.667 16c0-5.339-4.328-9.667-9.667-9.667S6.333 10.661 6.333 16s4.328 9.667 9.667 9.667",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "M14.23 8.667h3.54a.667.667 0 0 1 .64.858L17.71 12l2.232 14.95a.67.67 0 0 1-.268.64q-1.48 1.074-3.674 1.077t-3.675-1.077a.67.67 0 0 1-.267-.639L14.291 12l-.7-2.475a.667.667 0 0 1 .639-.858",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m16 18.667-3.918 2.726 1.382-4.569L9.66 13.94l4.773-.097L16 9.333l1.567 4.51 4.773.097-3.804 2.884 1.383 4.57z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMnp = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMnp_default = SvgFlagMnp;

export { FlagMnp_default as default };
